import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_WEBHOOK_SUBSCRIPTION_SORTABLE, WEBHOOK_SUBSCRIPTION_FILTERS } from '../vocabulary'
import { ACTIVE_CHOICES } from './components/filters'
import { webhookSubscriptionQuery, webhookSubscriptionsQuery } from './queries'

const webhookSubscriptionSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_WEBHOOK_SUBSCRIPTION_SORTABLE, [], WEBHOOK_SUBSCRIPTION_FILTERS, {
    active: ACTIVE_CHOICES,
  })

export const webhookSubscriptionsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('webhook_subscriptions'),
  path: '/webhook-subscriptions',
  validateSearch: webhookSubscriptionSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(webhookSubscriptionsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'WebhookSubscriptionsPage'),
})

export const webhookSubscriptionRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('webhook_subscriptions'),
  path: '/webhook-subscriptions/$id',
  validateSearch: webhookSubscriptionSearch,
  loader: ({ context, params }) =>
    context.queryClient.query(cached(webhookSubscriptionQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'WebhookSubscriptionPage'),
})

export const webhookSubscriptionRoutes = [webhookSubscriptionsRoute, webhookSubscriptionRoute]
